import { render, staticRenderFns } from "./OrganisationDialog.vue?vue&type=template&id=9969be92"
import script from "./OrganisationDialog.vue?vue&type=script&lang=js"
export * from "./OrganisationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9969be92')) {
      api.createRecord('9969be92', component.options)
    } else {
      api.reload('9969be92', component.options)
    }
    module.hot.accept("./OrganisationDialog.vue?vue&type=template&id=9969be92", function () {
      api.rerender('9969be92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/OrganisationDialog.vue"
export default component.exports